module.exports = __webpack_public_path__ + "img/ic-add-fund-red.8529b27a.svg";